import * as React from 'react';
import * as classess from '@styles/textLeft.module.css';

const TextLeft = (props) =>{
    const title = props.header.charAt(0).toUpperCase() + props.header.slice(1);

    return(
        <article className={classess.mainScreenTextLeft}>
            <h1>{title}</h1>
            <p>{props.textDescribe}</p>
        </article>
    );
}

export default TextLeft;